import React from 'react'
import { useLandscapeMode } from '../stores'

function LandscapeDependent({ children }) {
  const { status } = useLandscapeMode()
  return <>{status && <>{children}</>}</>
}

export default LandscapeDependent
